export interface IPreviewImage {
    caption: string,
    thumbnailData: any,
    thumbnailBlob: any,
    fullData: any
}